
import Vue from 'vue'
import { USER_LOGGED_IN } from '@/store/getter-types'
import QrCode from 'qrcode.vue'
import { Component, Prop } from 'vue-property-decorator'
import { CurrentUser } from '@/model/CurrentUser'
import { printSingleLabel } from '@/services/pdf-print'

@Component({
  components: {
    QrCode,
  }
})
export default class UserQrCode extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show!: boolean

  $refs!: {
    qrCode: InstanceType<typeof QrCode>
  }

  printInProgress: boolean = false

  get currentUser (): CurrentUser {
    return this.$store.getters[USER_LOGGED_IN]
  }

  get value (): string {
    return this.$store.getters[USER_LOGGED_IN].getBoarderQRCode
  }

  onCloseDialog () {
    this.$emit('close')
  }

  async generatePdf (): Promise<void> {
    try {
      this.printInProgress = true

      const qrCodeElement: HTMLCanvasElement | undefined = this.$refs.qrCode!.$refs['qrcode-vue'] as HTMLCanvasElement
      const qrCodeDataUrl: string = qrCodeElement.toDataURL()

      await printSingleLabel(qrCodeDataUrl, this.currentUser.fullName)
    } catch (error) {
      console.error('Error generating PDF:', error)
    } finally {
      this.printInProgress = false
    }
  }

  onPrintQrCodeClick (): void {
    this.generatePdf()
  }
}
